import {SelfVerificationButton} from "pages/mypage/my-info";
import {useContext} from "react";
import UserContext from "context/AuthContext";


const EventSelfVerificationComponent = (props) => {
    const {event, button, onCouponDownload} = props;

    const user = useContext(UserContext).user;

    const getSelfVerificationButtonClickedLocalStorageKey = (eventId, buttonId) => {
        return `self_verification_clicked_${eventId}_${buttonId}`;
    }

    const onSelfVerificationClick = (eventId, buttonId, alreadyVerified) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailSelfVerificationClick', {
            eventId: eventId,
            buttonId: buttonId,
            alreadyVerified: alreadyVerified
        });
        window.localStorage.setItem(getSelfVerificationButtonClickedLocalStorageKey(eventId, buttonId), 'true');
    }


    return (
        <>
            {
                !!user && !user.rrn ?
                    <SelfVerificationButton>
                        <div onClick={() => {
                            onSelfVerificationClick(event.id, button.id, false)
                        }} style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,}}/>
                    </SelfVerificationButton>
                    :
                    <div onClick={() => {
                        onSelfVerificationClick(event.id, button.id, true);
                        onCouponDownload(button.coupon_mold_keys);
                        window.localStorage.removeItem(
                            getSelfVerificationButtonClickedLocalStorageKey(event.id, button.id)
                        );
                    }} style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,}}/>
            }
        </>
    )
};

export default EventSelfVerificationComponent;
